"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packAstroSettings = exports.unpackAstroSettings = void 0;
function copyAstroSettingsCommon(data) {
    return {
        title: data.title,
        overSign: data.overSign,
        overSign0: data.overSign0,
        housesSystem: data.housesSystem,
        idCustomization: data.idCustomization,
        isRounded: data.isRounded,
        northernLatitude: data.northernLatitude,
        useNatalPlace: data.useNatalPlace,
        showHigherPlanets: data.showHigherPlanets,
        startingPoint: data.startingPoint,
        rotationDir: data.rotationDir,
        widgets: data.widgets,
        fixedStars: data.fixedStars,
        hideTransitAspects: data.hideTransitAspects,
        showMinorPlanets: data.showMinorPlanets,
        closureConfig: data.closureConfig,
        planetConnectionConfig: data.planetConnectionConfig,
        calendarType: data.calendarType,
    };
}
function unpackAstroSettings(p) {
    var maps = {};
    Object.keys(p.data.maps).forEach(function (mapId) {
        var map = p.data.maps[mapId];
        var orbises = {};
        Object.keys(map.orbises).forEach(function (aspType) {
            orbises[+aspType] = map.orbises[+aspType]
                .split(' ')
                .map(function (orb) {
                var disabled = orb[0] === '!';
                var major = orb[0] === '*';
                return {
                    disabled: disabled,
                    major: major,
                    value: Number(disabled || major ? orb.substr(1) : orb)
                };
            });
        });
        maps[mapId] = {
            orbises: orbises,
            orbiseCorrector: map.orbiseCorrector
        };
    });
    return __assign(__assign({ id: p.id, mutable: p.user_id !== -1 }, copyAstroSettingsCommon(p.data)), { maps: maps });
}
exports.unpackAstroSettings = unpackAstroSettings;
function packAstroSettings(data) {
    var maps = {};
    Object.keys(data.maps).forEach(function (mapId) {
        var orbises = {};
        var map = data.maps[mapId];
        Object.keys(map.orbises).forEach(function (aspType) {
            orbises[+aspType] = map.orbises[+aspType]
                .map(function (o) { return "".concat(o.major ? '+' : '').concat(o.disabled ? '!' : '').concat(o.value); })
                .join(' ');
        });
        maps[mapId] = {
            orbises: orbises,
            orbiseCorrector: map.orbiseCorrector
        };
    });
    return __assign(__assign({}, copyAstroSettingsCommon(data)), { maps: maps });
}
exports.packAstroSettings = packAstroSettings;
